<template src="./CustomComponent.html"></template>
<script>
  export default {
    data () {
      return {
        dato: 'Valor en memoria'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/CustomPackage/components/CustomComponent/CustomComponent.vue